import { render } from "./JobDetails.vue?vue&type=template&id=1ccb62a8&ts=true"
import script from "./JobDetails.vue?vue&type=script&lang=ts"
export * from "./JobDetails.vue?vue&type=script&lang=ts"

import "./JobDetails.vue?vue&type=style&index=0&id=1ccb62a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__